import { render } from "./CategorisedList.vue?vue&type=template&id=a9185d48"
import script from "./CategorisedList.vue?vue&type=script&lang=js"
export * from "./CategorisedList.vue?vue&type=script&lang=js"

import "./CategorisedList.vue?vue&type=style&index=0&id=a9185d48&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__